import { PDFDocument } from 'pdf-lib';

// Arma la URL absoluta de un archivo servido por el backend (mismo patron que
// ya se usa en VisitasAdmin.js / ReclamosAdmin.js / DashboardGeneral.js).
const urlArchivo = (hostApi, urlRelativa) =>
  `${hostApi}${urlRelativa}`.replace(/([^:])\/\/+/g, '$1/');

// Une en un unico PDF los comprobantes (PDF o imagen) de una lista de gastos.
// Cada PDF de origen aporta todas sus paginas; cada imagen se agrega como una
// pagina nueva. Se usa desde Gastos.js y desde el Dialog "Generar PDF" del
// Dashboard, para que el boton "Descargar Comprobantes" haga lo mismo en los
// dos lugares.
export async function descargarComprobantesUnificados({ gastos, hostApi, nombreArchivo, onError }) {
  const conComprobante = (gastos || []).filter((g) => g.urlComprobante);

  if (conComprobante.length === 0) {
    onError?.('No hay comprobantes para descargar en este período.');
    return;
  }

  const pdfFinal = await PDFDocument.create();
  let fallidos = 0;

  for (const gasto of conComprobante) {
    try {
      const res = await fetch(urlArchivo(hostApi, gasto.urlComprobante));
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const bytes = await res.arrayBuffer();

      const extension = gasto.urlComprobante.split('.').pop().toLowerCase();

      if (extension === 'pdf') {
        const pdfOrigen = await PDFDocument.load(bytes, { ignoreEncryption: true });
        const paginas = await pdfFinal.copyPages(pdfOrigen, pdfOrigen.getPageIndices());
        paginas.forEach((pagina) => pdfFinal.addPage(pagina));
      } else if (extension === 'jpg' || extension === 'jpeg' || extension === 'png') {
        const imagen = extension === 'png'
          ? await pdfFinal.embedPng(bytes)
          : await pdfFinal.embedJpg(bytes);
        const pagina = pdfFinal.addPage([imagen.width, imagen.height]);
        pagina.drawImage(imagen, { x: 0, y: 0, width: imagen.width, height: imagen.height });
      }
    } catch (err) {
      console.error('No se pudo agregar el comprobante', gasto.urlComprobante, err);
      fallidos++;
    }
  }

  if (pdfFinal.getPageCount() === 0) {
    onError?.('No se pudo descargar ningún comprobante.');
    return;
  }

  const bytesFinal = await pdfFinal.save();
  const blob = new Blob([bytesFinal], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = nombreArchivo || 'Comprobantes.pdf';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);

  if (fallidos > 0) {
    onError?.(`Se descargaron ${pdfFinal.getPageCount()} página(s); ${fallidos} comprobante(s) no se pudieron incluir.`, 'warn');
  }
}
